import { useService } from '@policoders/di';
import { Link } from 'react-router-dom';

import { NavbarItem } from './navbar-item.model';
import NavbarService from './navbar.service';

const NavItem = ({ label, to, type }: NavbarItem) =>
  type !== 'nav-item' ? (
    <></>
  ) : (
    <li className="nav-item">
      <Link className="nav-link" aria-current="page" to={to}>
        {label}
      </Link>
    </li>
  );

const DropdownItem = ({ label, to, type }: NavbarItem) =>
  type !== 'dropdown-item' ? (
    <></>
  ) : (
    <li>
      <Link className="dropdown-item" to={to}>
        {label}
      </Link>
    </li>
  );

const NavDropdown = ({ label, to, type, items }: NavbarItem) =>
  type !== 'dropdown' ? (
    <></>
  ) : (
    <li className="nav-item dropdown">
      <Link
        to={to}
        className="nav-link dropdown-toggle"
        role="button"
        data-bs-toggle="dropdown"
        aria-expanded="false">
        {label}
      </Link>
      <ul className="dropdown-menu" aria-labelledby="submenuDropdown">
        {items?.map((item, index) => (
          <DropdownItem key={'ddi' + index} {...item} />
        ))}
      </ul>
    </li>
  );

const ModuleNavbar: React.FC = () => {
  const navbarService = useService<NavbarService>('NavbarService');
  return (
    <>
      {navbarService.navbar.map((item, index) =>
        item.type === 'nav-item' ? (
          <NavItem key={'nvi-' + index} {...item} />
        ) : item.type === 'dropdown' ? (
          <NavDropdown key={'dd-' + index} {...item} />
        ) : undefined,
      )}
    </>
  );
};

export { ModuleNavbar };
